// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1944":"401a0ee4","3788":"33b8388a","4283":"33b8388a"}[chunkId] + ".chunk.css";
};